@if (agent$ | async; as agent) {
  <!-- body -->
  <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-1">
    @if (agentsService.exampleMessages.length > 0) {
      @for (message of agentsService.exampleMessages; track message) {
        <div
          class="card !px-4 !py-2 !shadow-none max-w-xl break-words whitespace-break-spaces"
          [ngClass]="{
            'self-start border !rounded-bl-sm border-black/10':
              fromAssistant(message),
            'self-end !bg-accent-600/10 !rounded-br-sm ': fromUser(message)
          }"
          [innerHTML]="message.content | markdown"></div>
      }
      @if (loadingResponse) {
        <span
          class="card !px-4 !py-2 !shadow-none self-start border !rounded-bl-sm border-black/10">
          <!-- 3 loading dots -->
          <div class="flex gap-1 min-h-6 items-center">
            @for (dot of [].constructor(3); track $index) {
              <div
                class="w-2 h-2 bg-black/20 rounded-full animate-bounce duration-75"
                [style.animation-delay]="$index * 0.1 + 's'"></div>
            }
          </div>
        </span>
      }
    } @else {
      <p class="text-balance text-center text-black/60 m-auto">
        Envie uma mensagem para testar seu agente.
      </p>
    }
  </div>

  <!-- footer -->
  <div
    class="flex items-center gap-2 p-4 border-solid border-0 border-t border-black/10">
    <textarea
      rows="1"
      class="resize-none flex-1 rounded-lg bg-white border border-solid border-black/10 focus:border-accent-600 px-4 py-2"
      [(ngModel)]="agentsService.messageContent"
      placeholder="Escreva sua mensagem..."
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="sendMessage()"></textarea>
    <button
      class="items-center content-center min-h-10 min-w-10 self-end p-0"
      [disabled]="!agentsService.messageContent"
      (click)="sendMessage()">
      <span class="material-symbols-rounded">send</span>
    </button>
  </div>
}
